import _ from 'lodash';
import {UserState} from '~/redux/reducers/UserReducer';
import {GlobalApplicationState} from '~/redux/reducers/RootReducer';

export const selectUserState = ({userState}: GlobalApplicationState): UserState => userState;

export const selectAuthToken = ({userState}: GlobalApplicationState): string | undefined =>
    userState.authToken;

export const selectUserHintsOrgIds = ({userState}: GlobalApplicationState): number[] => {
    return _.get(userState, 'hints.orgIds');
};

export const selectUsersHintsStoreIds = ({userState}: GlobalApplicationState): number[] => {
    return _.get(userState, 'hints.storeIds');
};
